import { type FC } from 'react';

import { QueryState } from '@/api/components/QueryState';
import { fundHoldingsApi } from '@/api/fundHoldings/fundHoldingsApi';
import { useFundListQuery } from '@/api/funds/fundsApi';
import { usePortfoliosQuery } from '@/api/portfolios';
import { isNotReady } from '@/api/utils/isNotReady';
import { useTexts } from '@/hooks/useTexts';
import { WithPortfolioGroupEsgData } from '@/pages/Esg/WithPortfolioGroupEsgData';

import { EsgOverview } from './EsgOverview';

interface Props {
  portfolioGroupId: string;
}

export const EsgOverviewWidget: FC<Props> = ({ portfolioGroupId }) => {
  const texts = useTexts();
  const portfoliosQuery = usePortfoliosQuery();

  // Downstream components require data from these queries.
  const fundListQuery = useFundListQuery();
  // Use useQueryState to read cached data without triggering a refetch.
  // DashboardPage already handles the holdings fetch.
  const holdingsQuery =
    fundHoldingsApi.endpoints.fetchFundHoldings.useQueryState(undefined);

  if (isNotReady([portfoliosQuery, fundListQuery, holdingsQuery])) {
    return (
      <>
        <h2>{texts.dashboard.widgets.esgOverview.title}</h2>

        <QueryState query={[portfoliosQuery, fundListQuery, holdingsQuery]} />
      </>
    );
  }

  return (
    <WithPortfolioGroupEsgData
      portfolioGroupId={portfolioGroupId}
      render={(data) => (
        <EsgOverview esgData={data} portfolioGroupId={portfolioGroupId} />
      )}
    />
  );
};
